import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.SECURITY);

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const securityService = {
  // Đổi mật khẩu đăng nhập
  changePassword: async (oldPassword, newPassword) => {
    try {
      const response = await axios.put(`${API_URL}/change-password`, { oldPassword, newPassword }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể đổi mật khẩu'));
    }
  },

  // Kiểm tra đã có PIN chưa
  checkPinStatus: async () => {
    try {
      const response = await axios.get(`${API_URL}/withdraw-pin/status`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể kiểm tra trạng thái PIN'));
    }
  },

  // Tạo PIN mới (lần đầu)
  setPin: async (pin, confirmPin) => {
    try {
      const response = await axios.post(`${API_URL}/withdraw-pin/set`, {
        pin,
        confirm_pin: confirmPin
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể thiết lập mã PIN'));
    }
  },

  // Đổi PIN
  changePin: async (oldPin, newPin, confirmPin) => {
    try {
      const response = await axios.post(`${API_URL}/withdraw-pin/change`, {
        old_pin: oldPin,
        new_pin: newPin,
        confirm_pin: confirmPin
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể đổi mã PIN'));
    }
  },

  // Verify PIN
  verifyPin: async (pin) => {
    try {
      const response = await axios.post(`${API_URL}/withdraw-pin/verify`, {
        pin
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Mã PIN không đúng'));
    }
  }
};
